import { authHeader } from '../_core/auth-header';
import Config from '../_core/config';

import OAuth from 'oauth-1.0a';
import crypto from 'crypto';

export const categoryService = {
    create,
    update,
    getAll,
    getById,
    getBySlug,
    remove,
    getWooCategories,
    getCategoryIDBySlug
};

function create(body) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(body)
    };

    return fetch(Config.api.basepath+`/category`, requestOptions).then(handleResponse) 
}

function update(body) {
    
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(body)
    };

    return fetch(Config.api.basepath+`/category/${body._id}`, requestOptions).then(handleResponse)    
}

function getAll(options) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let url = Config.api.basepath+`/category?`;

    url = options.page ? url + `page=` + options.page : url
    url = options.items ? url + `&per-page=` + options.items : url
    url = options.limit ? url + `&limit=` + options.limit : url;

    let filter = options.filter && Object.keys(options.filter).reduce(function (r, k) {
        return r.concat(k + ':' + options.filter[k]);
    }, []);

    url = options.filter ? url + `&filter=` + filter : url;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(
            categories => {
                let pages = parseInt(categories.total / categories['per-page']);
                pages = categories.total > ( pages * categories['per-page'] ) ? pages + 1 : pages;
                categories.pages = pages;

                return categories;
            },
            error => {
                return {error: 'Fetch Category Error. Service Unavailable.'};
            }
        );
}

function getById(id) {

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/category/${id}`, requestOptions).then(handleResponse)
}

function getBySlug(slug) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(Config.api.basepath+`/category/slug/${slug}`, requestOptions).then(handleResponse);
}

function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/category/`+id, requestOptions).then(handleResponse);
}


function getWooCategories() {


    const baseUrl = window.location.origin;
    // Fetch "new" tag
    const newTagRequestData = {
        url: `${baseUrl}/wp-json/wc/v3/products/categories`,
        method: 'GET'
    };
    const newTagHeaders = oauthFunction().toHeader(oauthFunction().authorize(newTagRequestData));

    return fetch(newTagRequestData.url, {
        method: newTagRequestData.method,
        headers: newTagHeaders
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to fetch "new" tag');
        }
        return response.json();
    })

}

function getCategoryIDBySlug(slug) {
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/wp-json/wc/v3/products/categories?slug=${slug}`;

    const requestConfig = {
        method: 'GET',
        headers: oauthFunction().toHeader(oauthFunction().authorize({ url, method: 'GET' }))
    };

    return fetch(url, requestConfig)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch category');
            }
            return response.json();
        })
        .then(categories => {
            if (categories.length > 0) {
               // console.log(categories)
                return categories;
            } else {
                throw new Error('Category not found');
            }
        });
}


function oauthFunction() {
    
    const oauth = OAuth({
        consumer: {
            key: Config.woocommerce.key,
            secret: Config.woocommerce.secret
        },
        signature_method: 'HMAC-SHA1',
        hash_function(baseString, key) {
            return crypto.createHmac('sha1', key).update(baseString).digest('base64');
        }
    });


    return oauth
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {

            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}